import { Modal, ModalHeader, ModalBody } from '@acb_devel/design-system';
import { useEventsContext } from '@contexts/EventsContext';
import type { Event } from '@services/events';
import { EventForm as EventFormComponent } from '@components/assessors/molecules/EventForm/EventForm';
import type { EventForm } from '@services/events';
import { updateEvent } from '@services/events';
import { useToastContext, ToastRoot, Alert } from '@acb_devel/design-system';

export function EditEventModal({
  isOpen,
  onClose,
  event,
}: {
  isOpen: boolean;
  onClose: () => void;
  event: Event;
}) {
  const { addToast } = useToastContext();
  const { events, setEvents } = useEventsContext();

  function updateEventSubmit(eventForm: EventForm) {
    if (!eventForm) {
      return;
    }

    updateEvent(event.id, eventForm).then((event) => {
      const updatedEvents = events.map((e) => (e.id === event.id ? event : e));
      setEvents(updatedEvents);
      onClose();
      addToast(
        <ToastRoot>
          <Alert variant="success" title={`Evento actualizado correctamente`} />
        </ToastRoot>
      );
    });
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalHeader closeModal={onClose}>Edita el evento</ModalHeader>
      <ModalBody>
        <EventFormComponent
          onSubmit={updateEventSubmit}
          submitButtonLabel="Guardar"
          defaultValues={event}
        />
      </ModalBody>
    </Modal>
  );
}
